// 挂到 flask 的 /web-site 时，静态资源和 Service Worker 都留在这条路由下。
// 独立 dev-server 和 BFF 仍从站点根提供，这里返回空前缀。
function siteBase() {
    if (typeof location === 'undefined') return '';
    const path = location.pathname;
    return path === '/web-site' || path.startsWith('/web-site/') ? '/web-site' : '';
}

function sitePath(urlPath) {
    const suffix = urlPath.startsWith('/') ? urlPath : `/${urlPath}`;
    if (suffix === '/') return siteBase() || '/';
    return `${siteBase()}${suffix}`;
}

module.exports = { siteBase, sitePath };
